"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    showFavoriteSuggestions: {
        datapoint: {
            name: 'TnS_ShowFavoriteSuggestions',
            customData: function (searchInputLength, peopleSuggestionCount, folderSuggestionCount, searchSuggestionCount, categorySuggestionCount) { return [
                searchInputLength,
                peopleSuggestionCount,
                folderSuggestionCount,
                searchSuggestionCount,
                categorySuggestionCount,
            ]; },
        },
    },
    addFavoriteFromPicker: {
        datapoint: {
            name: 'TnS_AddFavoriteFromPicker',
            customData: function (searchInputLength, favoriteSuggestionType) { return [searchInputLength, favoriteSuggestionType]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/datapoints.js
// module id = 6280
// module chunks = 68